var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38489 16.7817C6.70519 17.102 7.2245 17.102 7.5448 16.7817L12.7644 11.5621C13.0847 11.2418 13.0847 10.7225 12.7644 10.4022C12.4441 10.0819 11.9248 10.0819 11.6045 10.4022L6.96484 15.0419L2.32523 10.4022C2.00493 10.0819 1.48563 10.0819 1.16533 10.4022C0.845029 10.7225 0.845029 11.2418 1.16533 11.5621L6.38489 16.7817ZM6.14467 0.618423L6.14467 16.2018H7.78502L7.78502 0.618423H6.14467Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/arrowdown.6a95093b8133e4dcb53822f110201cb5.svg";
export { ForwardRef as ReactComponent };